import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";
import logoImg from "@/assets/logo-hitchef.png";
import { Music } from "lucide-react";

const AdBirthdayLanding = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    trackEvent("ad_birthday_landing_view", {
      utm_source: searchParams.get("utm_source") || "ad_birthday",
      utm_campaign: searchParams.get("utm_campaign") || undefined,
    });
  }, [searchParams]);

  const handleCTA = () => {
    trackEvent("ad_birthday_cta_click", {
      utm_source: searchParams.get("utm_source") || "ad_birthday",
    });
    const params = new URLSearchParams();
    searchParams.forEach((v, k) => params.set(k, v));
    if (!params.has("utm_source")) params.set("utm_source", "ad_birthday");
    navigate(`/create?${params.toString()}`);
  };

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <section className="px-5 pt-14 pb-12 max-w-lg mx-auto text-center">
        <img src={logoImg} alt="Хит Шеф" className="w-16 h-16 rounded-2xl mx-auto mb-6 shadow-md object-cover" width={64} height={64} />
        <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight mb-4 tracking-tight">
          Песня на День рождения<br /><span className="text-[#6C63FF]">за 3 минуты</span>
        </h1>
        <p className="text-gray-500 text-base mb-8 leading-relaxed">Удивите именинника персональной песней,<br className="hidden sm:block" /> созданной по&nbsp;вашей истории 🎂</p>
        <ul className="space-y-3 text-left max-w-xs mx-auto mb-10 text-[15px]">
          <li className="flex items-start gap-3"><span className="text-xl leading-none mt-0.5">🎁</span><span>Уникальный подарок — не&nbsp;цветы и&nbsp;не&nbsp;носки</span></li>
          <li className="flex items-start gap-3"><span className="text-xl leading-none mt-0.5">💬</span><span>Расскажите историю — AI напишет хит</span></li>
          <li className="flex items-start gap-3"><span className="text-xl leading-none mt-0.5">🎧</span><span>Сначала бесплатное демо</span></li>
          <li className="flex items-start gap-3"><span className="text-xl leading-none mt-0.5">⚡</span><span>Готово за 3 минуты, даже в&nbsp;последний момент</span></li>
        </ul>
        <button onClick={handleCTA} className="w-full max-w-xs mx-auto flex items-center justify-center gap-2 h-14 rounded-2xl text-lg font-bold text-white bg-[#6C63FF] hover:bg-[#5a52e0] active:scale-[0.97] transition-all shadow-lg shadow-[#6C63FF]/30">
          <Music className="w-5 h-5 shrink-0" />
          Создать песню на ДР
        </button>
        <p className="text-xs text-gray-400 mt-3">Демо бесплатно, займёт 3 минуты</p>
        <div className="mt-8 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gray-50 border border-gray-100">
          <span className="font-bold text-[#6C63FF]">12 000+</span>
          <span className="text-sm text-gray-500">хитов уже создано</span>
        </div>
      </section>

      <section className="px-5 py-12 bg-gray-50">
        <div className="max-w-lg mx-auto">
          <h2 className="text-xl font-bold text-center mb-8">Как это работает</h2>
          <div className="space-y-5">
            {[
              { n: "1", icon: "✍️", text: "Расскажите про именинника" },
              { n: "2", icon: "🎧", text: "Получите бесплатный демо-трек" },
              { n: "3", icon: "🎵", text: "Выкупите полную версию и удивите!" },
            ].map((s) => (
              <div key={s.n} className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-violet-100 text-violet-700 font-bold flex items-center justify-center shrink-0 text-sm">{s.n}</div>
                <div className="flex items-center gap-2"><span className="text-lg">{s.icon}</span><span className="text-[15px]">{s.text}</span></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-5 pt-10 pb-16">
        <div className="max-w-lg mx-auto text-center">
          <button onClick={handleCTA} className="w-full max-w-xs mx-auto flex items-center justify-center gap-2 h-14 rounded-2xl text-lg font-bold text-white bg-[#6C63FF] hover:bg-[#5a52e0] active:scale-[0.97] transition-all shadow-lg shadow-[#6C63FF]/30">
            <Music className="w-5 h-5 shrink-0" />
            Создать песню на ДР
          </button>
        </div>
      </section>
    </div>
  );
};

export default AdBirthdayLanding;
